<div class="form-header-container">
  <div class="row align-items-start">
    <app-form-status
      *ngFor="let i of formHeaderElementList"
      [formElement]="i"
      class="col"
    ></app-form-status>
  </div>
</div>
